import { coreClient } from '@/api/coreclient'
import type {
  OrganizationAttributes,
  UserAttributes,
  UserUpdatePayload,
  ScheduledReport
} from 'common'

export default {
  async resendVerifyEmail() {
    const client = await coreClient()
    return client.user
      .resendVerifyEmail()
      .then(() => {
        return true
      })
      .catch((e) => {
        console.error(e)
        return false
      })
  },
  async updateUserData(payload: UserUpdatePayload) {
    const client = await coreClient()
    return client.user
      .updateUserData(payload)
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return null
      })
  },
  async listOrganizationMembers() {
    const client = await coreClient()
    return client.user
      .listOrganizationMembers()
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return [] as UserAttributes[]
      })
  },
  async removeFromOrganization(userId: string, transferUserId?: string) {
    const client = await coreClient()
    return client.user
      .removeFromOrganization({ user_id: userId, transfer_user_id: transferUserId })
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return null
      })
  },
  async getOrganization() {
    const client = await coreClient()
    return client.user
      .getOrganization()
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return null
      })
  },
  async updateOrganization(id: number, org: Omit<OrganizationAttributes, 'id'>) {
    const client = await coreClient()
    return client.user
      .patchOrganization(id, org)
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return null
      })
  },
  async invitePeople(emails: string[]) {
    const client = await coreClient()
    return client.user
      .invitePeople({ emails })
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return null
      })
  },
  async seatUpdateInvoice(seats: number) {
    const client = await coreClient()
    return client.user
      .seatUpdateInvoice(seats)
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return {
          amount_due: 0,
          total: 0,
          discount: null,
          subtotal: 0
        }
      })
  },
  async resendInviteEmail(email: string) {
    const client = await coreClient()
    return client.user
      .resendInviteEmail(email)
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return null
      })
  },
  async getInvitation() {
    const client = await coreClient()
    return client.user
      .getInvitation()
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return null
      })
  },
  async acceptInvitation() {
    const client = await coreClient()
    return client.user
      .acceptInvitation()
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return null
      })
  },
  async denyInvitation() {
    const client = await coreClient()
    return client.user
      .denyInvitation()
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return null
      })
  },
  async getPeopleInOrgOrShared() {
    const client = await coreClient()
    return client.user
      .getPeopleInOrgOrShared()
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return []
      })
  },
  async listOrganizationReportAccesses() {
    const client = await coreClient()
    return client.user
      .listOrganizationReportAccesses()
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return []
      })
  },
  async getSchedules() {
    const client = await coreClient()
    return client.user
      .getSchedules()
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return [] as ScheduledReport[]
      })
  },
  async unsubscribeFromSchedule(id: number) {
    const client = await coreClient()
    return client.user
      .unsubscribeFromSchedule(id)
      .then(() => {
        return true
      })
      .catch((e) => {
        console.error(e)
        return false
      })
  }
}
